'use strict'
/**
 * Module qui gère l'affichage du contenu du champ mdp au click
 */

import modal from 'Modules/modal'
import bootstrapValidationForm from 'Modules/bootstrapValidationForm'
import inscriptionConnexionCustomAction from 'Modules/inscriptionConnexionCustomAction'

const J_PRINT_PASSWORD = '.j_printPassword'
const J_PASSWORD = '.j_password'
const J_AFFICHER_VALUE = 'AFFICHER'
const J_MASQUER_VALUE = 'MASQUER'

/*
 * Set l'event sur le lien 'affichage' pour afficher ou masquer le contenu du champ password
 */
function setEventForPrintingPassword() {
    $(J_PRINT_PASSWORD).on('click', function (event) {
        const $password = $(J_PASSWORD)

        if ($password !== undefined) {
            if ($password.attr('type') === 'password') {
                $password.attr('type', 'text')
                $(event.currentTarget).empty().append(J_MASQUER_VALUE)
            } else if ($password.attr('type') === 'text') {
                $password.attr('type', 'password')
                $(event.currentTarget).empty().append(J_AFFICHER_VALUE)
            }
        }

        return false
    })
}

/**
 * Mot de passe oublié
 */
function setEventMotDePasseOublie() {
    $('#passwordPerdu').click(function () {
        modal.creer(
            'modalMotdepassePerdu',
            'fade m-password-forgotten modal-pass-forgot in',
            window.location.origin + '/Inscription/ModalMotdepassePerdu/',
            initModalMotdepassePerdu
        )
    })

    function initModalMotdepassePerdu() {
        const J_PASSWORD_FORGOTTEN_FORM_ID = '.j-pwdForgotten'
        const J_PASSWORD_FORGOTTEN_ID = '.modal-pass-forgot'

        bootstrapValidationForm.initModalForm(
            J_PASSWORD_FORGOTTEN_ID,
            J_PASSWORD_FORGOTTEN_FORM_ID,
            inscriptionConnexionCustomAction.recoverPassword
        )
    }
}

export default {
    setEventForPrintingPassword: setEventForPrintingPassword,
    setEventMotDePasseOublie: setEventMotDePasseOublie
}
